import styled from 'styled-components';

import { styledReset } from '@pkg/primitives';

import { commonCssVars, commonCssVarsDark } from './styles-vars';
import { tokens } from './tokens';

interface StyledEmojiListProps {
    $darkMode?: boolean;
}

export const StyledEmojiList = styled.div<StyledEmojiListProps>`
    ${styledReset.borderBox};
    ${({ $darkMode }) => ($darkMode ? commonCssVarsDark : commonCssVars)};
`;

export const List = styled.ul`
    ${styledReset.list};
    display: grid;
    grid-template-columns: repeat(auto-fill, ${tokens.emoji.size}px);
    justify-content: space-between;
    gap: ${tokens.list.gap}px;
`;

export const Item = styled.li``;
